import { ControlType, Property, PropertyType } from "../../../base/types";

import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const YouTubeComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const videoId: string | undefined = properties[Property.VideoId];
    const tooltip: string | undefined = properties[Property.Tooltip];

    return (
        <div className={className} title={tooltip}>
            {videoId && <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${videoId}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
            />}
        </div>
    )
}

Registry.addControl({
    id: "f2cce836-2e08-4d28-bedc-2c02e28e0b53",
    name: "YouTube",
    type: ControlType.YouTube,
    properties: [
        { id: Property.VideoId, name: 'Video Id', type: PropertyType.String },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: YouTubeComponent
})
